<template>
	<div class="training">
		<HeadModule :openTarget="'webView/detail?url=' + encodeURIComponent(apppagebase + '/training?hideNativeNav=1&trainId=' + trainId + '&type=1')"/>
		<!-- 培训计划内容 -->
		<div class="header-bg">
			<div class="bg-img">
				<van-image lazy-load :src="cover" fit="cover" />
			</div>
			<!-- 类型 -->
			<div class="type">
				<div class="type-bg"></div>
				<div class="type-txt">培训计划1</div>
			</div>
			<!-- 其他信息 -->
			<div class="other">
				<div class="other-item">共{{ trainingInfo.contentNum }}个内容<span class="dot">·</span>{{ trainingInfo.videoTime }}</div>
				<div class="other-item">
					<div class="avg">
						<van-image v-for="item in learnList" :key="item.id" lazy-load :src="item.photoUrl" round />
					</div>
					<span>{{ trainingInfo.studyNum }} 人在学</span>
				</div>
			</div>
		</div>
		<!-- 培训计划详情 -->
		<div class="info">
			<div class="title">{{ trainingInfo.name }}</div>
			<div class="item-content" v-if="trainingInfo.subTitle">
				<MultiLineExpandsCollapses id="sub-title" :content="trainingInfo.subTitle" />
			</div>
			<div class="price">
				<p v-if="trainingInfo.price > 0">
					<span class="price-num">{{ trainingInfo.price }}</span> 巢币
				</p>
				<p v-else>
					<span class="price-num">免费</span>
				</p>
			</div>

			<!-- 营期切换 -->
			<div class="semesterCon" @click="semesterListShow = true">
				<p>{{ newSemester.semesterName }}</p>
				<div class="semesterConRight">
					<div v-if="newSemester.studyTimeStart">{{ newSemester.studyTimeStart }} ~ {{ newSemester.studyTimeEnd }}</div>
					<img :src="nextIcon" alt="">
				</div>
			</div>
		</div>
		<!-- 培训证书 -->
		<div class="certificate" v-if="trainingInfo.certId" @click="certificateShow = true">
			<div class="title">培训证书</div>
			<div class="certificate-info">
				<div class="pic">
					<van-image class="info-img" lazy-load :src="certImg" />
					<img class="vip" :src="vipIcon" alt="官方">
				</div>
				<div class="main">
					<div class="name">
						<div class="name-txt van-multi-ellipsis--l2">{{ trainingInfo.certInfo.name }}</div>
					</div>
					<div class="people">
						{{ trainingInfo.certInfo.obtainNum }}人已获得
					</div>
					<div class="txt">完成培训并达到合格标准后，可获得该证书。</div>
				</div>
			</div>
		</div>
		<!-- 介绍 -->
		<div class="tabs">
			<van-tabs v-model="currentIdx" swipeable>
				<van-tab>
					<template #title>
						<div class="tab-item">
							<span>介绍</span>
						</div>
					</template>
					<template #default>
						<div class="tab-content">
							<!-- 介绍 -->
							<div class="editor-box">
								<WangEditor v-if="trainingInfo.introduce" :introduce="trainingInfo.introduce"></WangEditor>
								<div class="no-data" v-else>
									<img :src="NoData" alt="">
									<span>暂无内容～</span>
								</div>
							</div>
						</div>
					</template>
				</van-tab>
				<van-tab>
					<template #title>
						<div class="tab-item">
							<span>目录</span>
							<div class="try-mark" v-if="trainingInfo.canTryLook">试看</div>
						</div>
					</template>
					<template #default>
						<div class="tab-content">
							<Catalog v-if="trainingInfo" :trainingInfo="trainingInfo"></Catalog>
						</div>
					</template>
				</van-tab>
				<van-tab>
					<template #title>
						<div class="tab-item">
							<span>评论</span>
						</div>
					</template>
					<template #default>
						<div class="tab-content">
							<Comment v-if="trainingInfo.id" :trainId="trainingInfo.id" :type="2"></Comment>
						</div>
					</template>
				</van-tab>
			</van-tabs>
		</div>
		<div class="big-btn">
			<div class="pay">去电巢APP学习</div>
			<WxOpenTag :extinfo="'webView/detail?url=' + encodeURIComponent(apppagebase + '/training?hideNativeNav=1&trainId='  + trainId + '&type=1')"/>
		</div>
		<!-- 证书弹窗 -->
		<van-overlay :show="certificateShow" @click="certificateShow = false" z-index="9999" :lock-scroll="true">
			<div class="certificate-box" v-if="trainingInfo.certInfo">
				<div class="certificate-title van-multi-ellipsis--l2" @click.stop>{{ trainingInfo.certInfo.name }}</div>
				<div class="certificate-content" @click.stop>
					<img :src="certImg" alt="证书">
				</div>
				<div class="certificate-close">
					<van-icon name="cross" color="#fff" size="20px"/>
				</div>
			</div>
		</van-overlay>

		<!-- 营期弹框 -->
		<div class="semesterPopup" v-show="semesterListShow" @click="semesterListShow = false">
			<div class="semesterPopupCon">
				<p class="semesterTitle">选择营期</p>
				<div class="semesterList">
					<div class="semesterListCon" v-for="(item, index) in semesterList" :key="index" @click.stop="getSemester(item.trainId, index)">
						<div class="semesterTime">
							<p>{{ item.semesterName }}</p>
							<div v-if="item.studyTimeStart">开课时间：{{ item.studyTimeStart }} ~ {{ item.studyTimeEnd }}</div>
							<div v-else> 开课时间：暂未设置 </div>
						</div>
						<img v-if="item.trainId == trainId" :src="tabIcon" alt="">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import HeadModule from '@/components/HeadModule'
import WxOpenTag from "@/components/WxOpenTag.vue";
import WxShare from "@/utils/wxshare";
import VipPic from "@/assets/image/learning/ic_vip.png";
import NoData from "@/assets/image/learning/no_data.png";
import NoComment from "@/assets/image/learning/no_comment.png";
import WangEditor from "@/components/WangEditor.vue"; // 导入富文本编辑器
import Catalog from '@/page/training/components/Catalog' // 导入目录组件
import Comment from '@/page/training/components/Comment'
import { getImageUrl,isHttp } from "@/utils/upload";
import MultiLineExpandsCollapses from "@/page/details/components/MultiLineExpandsCollapses.vue";
import { apppagebase, educbase } from '@/utils/http'
import nextPic from "@/assets/image/learning/next_ic@3x.png";
import semesterTabPic from "@/assets/image/learning/ic_good@3x.png";
import utils from '@/utils/utils.js';

export default {
	components: {
		MultiLineExpandsCollapses,
		Catalog,
		Comment,
		WangEditor,
		WxOpenTag,
		HeadModule: HeadModule,
	},
	data() {
		return {
			// vip图标
			vipIcon: VipPic,
			NoData: NoData,
			NoComment: NoComment,
			// 培训计划封面
			cover: "",
			// 证书封面
			certImg: "",
			trainingInfo: {},
			learnList: [],
			// 当前tab
			currentIdx: 0,
			trainId:"",
			isOpen: false, // 是否展开
			apppagebase: apppagebase, // app页面地址
			certificateShow: false,

			newSemester: {},
			semesterList: [],
			semesterIndex: 0,
			semesterListShow: false, //营期列表显示
			// 更多营期icon
			nextIcon: nextPic,
			tabIcon: semesterTabPic,
			educbase: educbase,
		}
	},
	created() {
		if (!utils.browserChecker.isMobile()) {
			window.location.href = educbase + '/learning/trainInfo?id=' + this.$route.query.trainId;
		}
		this.trainId = this.$route.query.trainId ? this.$route.query.trainId : ""
		// this.semesterIndex = this.$route.query.tab ? this.$route.query.tab : 0
		this.init();
		this.viewTrain();
		this.getTrainingDetail();
	},
	watch: {
		// 监听遮罩层的显示和隐藏
		certificateShow(val) {
			if (val) {
				document.body.style.overflow = "hidden";
			} else {
				document.body.style.overflow = "scroll";
			}
		}
	},
	methods: {
		init() {
			this.getWx = new WxShare();
		},
		// 培训计划详情记录浏览数据 kc/app/cTrain/view
		viewTrain(){
			// 请求接口/app/cTrain/view
			let formData = new FormData();
			formData.append('api', 'kc/app/cTrain/view');
			formData.append('resourceId', this.trainId);
			formData.append('type', 2);
			this.$http({
				url: '/ipd/commonApi',
				method: 'post',
				data: formData
			})
		},
		// 培训计划详情-售前详情 V-3.1.0
		getTrainingDetail() {
			// 请求接口/app/cTrain/train/detail
			let formData = new FormData();
			formData.append('api', 'kc/app/cTrain/train/detail');
			formData.append('id', this.trainId);
			this.$http({
				url: '/ipd/commonApi',
				method: 'post',
				data: formData
			}).then((res) => {
				if(res.code === 0){
					this.trainingInfo = res.data;
					// 改变h5标题
					document.title = this.trainingInfo.name ? this.trainingInfo.name : "培训计划详情";
					// 封面
					if(this.trainingInfo.cover){
						getImageUrl(this.trainingInfo.cover, (imgUrl) => {
							this.cover = imgUrl
							/* 微信分享 */
							this.getWx.share({
								title: this.trainingInfo.name,
								desc: '电子产业链人才智慧培养和提升一站式数字化服务平台',
								link: window.location.href,
								imgUrl: this.cover
							});
						})
					}
					// 证书图片
					if(this.trainingInfo.isAward){
						getImageUrl(this.trainingInfo.certInfo.filePath, (imgUrl) => {
							this.certImg = imgUrl
						})
					}
					// 处理对应的课程封面 => 无章节
					if (this.trainingInfo.isPhase === 0) {
						this.trainingInfo.trainContentList.forEach((item) => {
							if(item.cover){
								getImageUrl(item.cover,(imgUrl)=>{
									item.coverUrl = imgUrl;
								})
							}
						});
					}else if(this.trainingInfo.isPhase === 1){
						// 处理对应的课程封面 => 有章节
						this.trainingInfo.trainPhaseList.forEach((item) => {
							if(item.contentList && item.contentList.length > 0){
								item.contentList.forEach((itm) => {
									if(itm.cover){
										getImageUrl(itm.cover,(imgUrl)=>{
											itm.coverUrl = imgUrl;
										})
									}
								});
							}
						});
					}
					// 学习人数
					if(this.trainingInfo.recentStudyUserList && this.trainingInfo.recentStudyUserList.length > 0){
						this.learnList = this.trainingInfo.recentStudyUserList;
						// 处理头像
						this.learnList.forEach((item) => {
							if(item.photo && !isHttp(item.photo)){
								getImageUrl(item.photo,(imgUrl)=>{
									item.photoUrl = imgUrl;
								})
							}else{
								item.photoUrl = item.photo;
							}
						});
					}

					// 售前页营期数组
					this.semesterList = res.data.semesterList.reverse();
					// 显示营期
					for(var i=0; i<this.semesterList.length; i++) {
						if(this.trainId == this.semesterList[i].trainId){
							this.semesterIndex = i
						}
					}
					this.newSemester = this.semesterList[this.semesterIndex];
				}else if(res.code < 0){
					// 不存在或者下架
					this.$router.replace({
						path: '/learningEmpty',
					})
				}
			});
		},
		// 切换tab
		changeIdx(index) {
			this.currentIdx = index
		},

		// 营期切换
		getSemester(tid, index) {
			this.trainId = tid;
			this.semesterListShow = false;
			this.semesterIndex = index;
			
			this.$router.push({
        path: '/training',
        query: {
          trainId: this.trainId,
					tab: index,
        }
      });

			this.getTrainingDetail();
		}
	}
}
</script>
<style scoped lang="css">
*{
	box-sizing: border-box;
}
.training{
	display: flex;
	flex-direction: column;
	position: relative;
	background: #F7F8F8;
	padding-bottom: 98px;
	min-height: 100%;
}
.big-btn{
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	position: fixed;
	bottom: 0;
	left: 0;
	z-index: 1100;
	background: #FFFFFF;
	padding: 10px 15px 10px;
	box-sizing: border-box;
}
.big-btn .pay{
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 49px;
	background: #E6001F;
	border-radius: 24px;
	font-size: 18px;
	color: #FFFFFF;
}
.header-bg{
	position: relative;
	width: 100%;
	height: 211px;
}
.bg-img{
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
}
.bg-img .van-image{
	width: 100%;
	height: 100%;
}
.type{
	position: absolute;
	bottom: 37px;
	left:15px;
}
.type .type-bg{
	width: 67px;
	height: 20px;
	background: rgba(49,49,49,0.56);
	border-radius: 10px 0 10px 0;
	backdrop-filter: blur(20px);
	box-shadow: 0 0 30px 10px rgba(0, 0, 0, .3);
}
.type .type-txt{
	width: 67px;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	font-size: 13px;
	color: #FFFFFF;
	text-align: center;
	line-height: 19px;
}
.other{
	position: absolute;
	bottom: 0;
	left: 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	height: 44px;
	background: linear-gradient( 180deg, rgba(0,0,0,0) 0%, #2B2B2B 100%);
	padding: 13px 15px 5px;
}
.other-item{
	display: flex;
	align-items: center;
	font-size: 12px;
	color: #FFFFFF;
	line-height: 17px;
}
.other-item .dot{
	margin: 0 10px;
}
.other-item .avg{
	display: flex;
	align-items: center;
	margin-right: 7px;
}
.other-item .avg .van-image{
	width: 26px;
	height: 26px;
	border-radius: 50%;
	margin-right: -4px;
	border: 1px solid #FFFFFF;
}
.info{
	padding: 15px;
	background: #FFFFFF;
	margin-bottom: 8px;
}
.info .title{
	max-height: 48px;
	font-weight: 600;
	font-size: 17px;
	color: #1D2023;
	line-height: 24px;
	text-align: justify;
	font-style: normal;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	margin-bottom: 15px;
}
.info .price{
	color: #E6001F;
	font-size: 12px;
}
.info .price-num{
	font-weight: 600;
	font-size: 17px;
}
.certificate{
	padding: 15px;
	background: #FFFFFF;
	margin-bottom: 8px;
}
.certificate .title{
	font-weight: 600;
	font-size: 17px;
	color: #1D2023;
	line-height: 24px;
	margin-bottom: 10px;
}
.certificate-info{
	display: flex;
}
.certificate-info .pic{
	position: relative;
	width: 137px;
	height: 97px;
	margin-right: 10px;
	border-radius: 4px;
}
.certificate-info .pic .info-img{
	position: absolute;
	left: 0;
	width: 137px;
	height: 97px;
	border-radius: 4px;
	z-index: 100;
}
::v-deep .certificate-info .pic .info-img .van-image__img{
	object-fit: contain;
}
.certificate-info .pic .vip{
	position: absolute;
	left: 0;
	top: 0;
	width: 66px;
	height: 20px;
	z-index: 120;
}
.certificate-info .main{
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
.main .name{
	display: flex;
	align-items: center;
}
.main .name .name-txt{
	font-weight: 600;
	font-size: 16px;
	color: #333333;
	line-height: 21px;
}
.main .people{
	font-weight: 600;
	font-size: 12px;
	color: #F53F3F;
	margin-top: auto;
	margin-bottom: 5px;
}
.main .txt{
	font-size: 12px;
	color: #8C8C8C;
	line-height: 16px;
}
.tabs{
	flex: 1;
	background: #FFFFFF;
	margin-bottom: 15px;
}
::v-deep .van-tabs__wrap{
	position: sticky;
	top: 0;
	z-index: 1100;
	height: 45px;
	border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
	background-color: #fff;
	box-sizing: border-box;
}
::v-deep .van-tabs__wrap .van-tabs__nav{
	padding: 0 26px;
	justify-content: space-between;
}
::v-deep .van-tabs__wrap .van-tabs__line{
	bottom: 0;
}
::v-deep .van-tabs__wrap .van-tabs__nav .van-tab{
	flex: none;
	padding: 0;
}
::v-deep .van-tabs__wrap .van-tab__text{
	font-weight: 400;
	font-size: 18px;
	color: #333333;
	overflow: initial;
}
::v-deep .van-tabs__wrap .van-tab--active .van-tab__text{
	color: #E6001F;
	font-weight: 600;
}
.tab-item{
	position: relative;
	display: flex;
	align-items: center;
}
.tab-item .try-mark{
	position: absolute;
	right:-46px;
	top: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 21px;
	background: #FFFFFF;
	border-radius: 11px;
	border: 1px solid #F7443F;
	font-size: 11px;
	color: #F7443F;
	padding: 3px 8px;
	font-weight: 400;
	z-index: 1200;
}
.tab-content .editor-box{
	padding: 10px;
}
.no-data{
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 40px 0;
	font-weight: 400;
	font-size: 13px;
	color: #C0C4CC;
}
.no-data img{
	width: 113px;
	height: 113px;
	margin-bottom: 5px;
}
.item-content {
	display: flex;
	margin-bottom: 15px;
}

.certificate-box {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
	width: 100%;
	padding: 25px;
}

.certificate-box .certificate-title {
	font-size: 18px;
	color: #FFFFFF;
	margin-bottom: 20px;
}

.certificate-content img {
	width: 100%;
	max-height: 354px;
	object-fit: contain;
}

.certificate-close {
	margin-top: 25px;
}

/* 营期 */
.semesterCon {
	box-sizing: border-box;
	padding: 0 15px;
	width: 100%;
	height: 46px;
	margin-top: 9px;
	background-color: #F7F8F8;
	border-radius: 5px;
	display: flex;
	justify-content: space-between;	
	align-items: center;
	text-align: center;
	font-size: 16px;
	color: #333333;
	font-size: 14px;
}

.semesterCon p{
	font-weight: 600;
}

.semesterConRight {
	display: flex;
	justify-content: flex-end;	
	align-items: center;
	text-align: center;
}

.semesterCon div {
	width: 256px;
}

.semesterCon img {
	width: 10px;
}

/* 营期列表 */
.semesterPopup {
	position: fixed;
	top: 0;
	left: 0;
	z-index: 9999;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, .7);
}

.semesterPopupCon {
	position: absolute;
	bottom: 0;
	box-sizing: border-box;
	border-radius: 25px 25px 0 0;
	background-color: #FFF;
	width: 100%;
	height: 375px;
	overflow-y: auto;
}

.semesterTitle {
	border-radius: 25px 25px 0 0;
	position: sticky;
	top: 0;
	width: 100%;
	padding: 10px 0;
	background-color: #FFF;
	font-size: 18px;
	font-weight: 600;
	color: #1D2023;
	text-align: center;
}

.semesterList {
	width: 100%;
}

.semesterListCon {
	box-sizing: border-box;
	padding: 0 20px;
	height: 80px;
	color: #333333;
	border-bottom: 0.5px solid #F5F5F6;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.semesterTime p {
	font-size: 16px;
	font-weight: 600;
}

.semesterTime div {
	font-size: 14px;
	color: #555;
	margin-top: 6.5px;
}

.semesterListCon img {
	width: 21px;
	height: 21px;
}
</style>